import { createSlice } from "@reduxjs/toolkit";

const sellerMenuSlice = createSlice({
  name: "sellerMenu",

  initialState: {
    activeMenu: "",
    aiChatOpen: false,   // Claude: AI Chat drawer open state 24-02-2026
    aiChatContext: "dashboard", // Claude: context drives opening message 24-02-2026
  },

  reducers: {
    setActiveMenu: (state, action) => {
      if (action.payload.activeMenu !== undefined) state.activeMenu = action.payload.activeMenu;
      if (action.payload.aiChatOpen !== undefined) {
        state.aiChatOpen = action.payload.aiChatOpen;
      }
      if (action.payload.aiChatContext !== undefined) {
        state.aiChatContext = action.payload.aiChatContext;
      }
    },
  },
});

export const { setActiveMenu } = sellerMenuSlice.actions;

export const sellerMenuReducer = sellerMenuSlice.reducer;
